import lazyLoadOnRender from '../lazy/loadOnRender';

const RebrandingBanner = () => import(/* webpackChunkName: "4-feat-rebranding-banner" */ './NonAdminRebrandingBanner');

export default lazyLoadOnRender({ loader: RebrandingBanner });
